// src/ApiPanel/components/ApiPanelFooter.jsx
import React from "react";
import { Link } from "react-router";

export default function ApiPanelFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="apip-footer">
      <span>© {year} API Panel. All rights reserved.</span>
      {/* <Link>, not <a href> — an anchor here reloaded the whole SPA. */}
      <Link to="/api-panel/complaint">Need Help?</Link>
    </footer>
  );
}
